import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const addObj = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicletype/add' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const getAll = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicletype/all' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const searchByName = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicletype/searchbyname/' + params.name + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getPage = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicletype/' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getDetail = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicletype/' + params.id + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const modifyObj = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicletype/modify' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const deleteObj = (params, urlParams) => {
  return axios.request({
    url: '/crm/vehicletype/' + params.id + '' + genURLParams(urlParams),
    method: 'DELETE',
    credentials: 'include',
    data: params
  })
}

